import React, { useEffect, useState } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import plastic1 from "../../assets/images/plastic-1.png";
import isEmpty from "../../utils/is-Empty";
import convertToLiters from "../../utils/convertToLiters";

const EnquirySummaryCard = ({ card }) => {
  const navigate = useNavigate();
  const [currentObject, setCurrentObject] = useState({});
  const [otherDetails, setOtherDetails] = useState({});

  useEffect(() => {
    let mCardObj = { ...card };

    if (!mCardObj.image_url) {
      mCardObj.image_url = plastic1;
    }

    setCurrentObject(mCardObj);

    if (!isEmpty(mCardObj?.other_details)) {
      let mDetails = JSON.parse(mCardObj.other_details);
      setOtherDetails(mDetails);
      console.log(">>> OTHER DETAILS: ", mDetails);
    }

    console.log(">>> ENQUIRY DETAILS: ", mCardObj);
  }, []);

  const handleClick = (e, value) => {
    navigate(`/product/${value}`);
  };

  return (
    <Row className="m-0 order-summery-card mb-4" key={currentObject?.enquiry_id}>
      <Col
        xs={3}
        sm={3}
        md={2}
        className="image-col"
        style={{ cursor: "pointer" }}
        onClick={(e) => handleClick(e, `${currentObject?.product_variant_id}`)}
      >
        <Image style={{ borderRadius: "10px" }} src={currentObject?.image_url} alt="plastic1" />
      </Col>
      <Col xs={9} sm={9} md={10} className="description-col">
        <div className="summary-card-title">
          <h5
            onClick={(e) => handleClick(e, currentObject?.product_variant_id)}
            style={{ cursor: "pointer" }}
          >
            {(() => {
              if (currentObject?.offer_price) {
                return (
                  <>
                    {currentObject?.brand_name} - {currentObject?.product_name} |{" "}
                    {`₹ ${currentObject?.offer_price}/case `}
                    <s>
                      {`₹ ${currentObject?.price}/`}
                      <span>{"case"}</span>
                    </s>
                  </>
                );
              } else {
                return (
                  <>
                    {currentObject?.brand_name} - {currentObject?.product_name} |{" "}
                    {`₹ ${currentObject?.price}/case`}
                  </>
                );
              }
            })()}
          </h5>
        </div>
        <hr style={{ width: "75%" }} />
        <div className="summary-card-details">
          <Row className="m-0">
            <Col xs={12} sm={12} md={12} className="summary-card-details-col">
              <Row className="summary-card-qnt">
                <Col xs={4} sm={2} md={2} className="summary-card-item">
                  <p>{"Size"}</p>
                  <h6>{convertToLiters(otherDetails.variant)}</h6>
                </Col>
                <Col xs={4} sm={2} md={2} className="summary-card-item">
                  <p>{"MOQ"}</p>
                  <h6>
                    {currentObject?.moqData?.displayName}&nbsp;{"Case"}
                  </h6>
                </Col>
                <Col xs={4} sm={2} md={2} className="summary-card-item">
                  <p>{"Amount"}</p>
                  {(() => {
                    if (!isEmpty(currentObject?.offer_price)) {
                      return (
                        <h6 className="amount strong">
                          {"₹ "}
                          {(
                            parseFloat(currentObject.moq) * parseFloat(currentObject.offer_price)
                          ).toFixed(2)}
                        </h6>
                      );
                    } else {
                      return (
                        <h6 className="amount strong">
                          {"₹ "}
                          {(
                            parseFloat(currentObject.moq) * parseFloat(currentObject.price)
                          ).toFixed(2)}
                        </h6>
                      );
                    }
                  })()}
                </Col>
                <Col xs={4} sm={2} md={3} className="summary-card-item"></Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default EnquirySummaryCard;
